import { getShouldShowWarningBanner } from "../../../../state/modules/savedItems/selectors";
import content from "app-content";

export default state => {
  if (getShouldShowWarningBanner(state)) {
    return content.back_in_stock_saved_items_notify_me_prompt;
  }
};
